module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel3-cleaning-en-GB@3x-4b3e8da241e4f2c2315669a1adfcfee0.png";